import { create } from 'zustand';
import { useCallback } from 'react';
import { Price } from '../../interfaces/sports';
import { OddsType } from '../../interfaces/configurationInterfaces';

export const useGetOddsFromPrice = () => {
  const oddsType = useConfigStore((s) => s.oddsType);

  return useCallback(
    (price?: Price) => {
      if (!price) return 'SP';
      switch (oddsType) {
        case 'fractional':
          if (price.fractional === '0/0' || !price.fractional) return 'SP';
          return price.fractional;
        case 'american':
          if (price.american === 0 || !price.american) return 'SP';
          return price.american;
        case 'decimal':
          if (price.decimal === 0 || !price.decimal) return 'SP';

          return price.decimal.toFixed(2);
      }
    },
    [oddsType],
  );
};

export interface ConfigStoreState {
  oddsType: OddsType;
  setOddsType: (oddsType: OddsType) => void;
  countryCode?: string;
  countryRegion?: string;
  gameTitle?: string;
  setGameTitle: (gameTitle?: string) => void;
  setCountryCode: (countryCode?: string) => void;
  setCountryRegion: (countryRegion?: string) => void;
}

export const useConfigStore = create<ConfigStoreState>()((set) => ({
  oddsType: 'fractional',
  setOddsType: (oddsType) => set(() => ({ oddsType })),
  setCountryCode: (countryCode) => set(() => ({ countryCode })),
  setCountryRegion: (countryRegion) => set(() => ({ countryRegion })),
  setGameTitle: (gameTitle) => set(() => ({ gameTitle })),
}));

export function isAusGame(countryCode: string | null | undefined): boolean {
  if (!countryCode) return false;
  return ['AU', 'MS'].includes(countryCode);
}
